module.exports = __webpack_public_path__ + "static/img/logo.a274ba86.png";